import { paciente } from '../../api/paciente';
import { usePedido } from '../../api/usePedido';
import { Enlace, irA } from '../../router';
import { useSesion } from '../../session/Sesion';
import { Boton, EstadoVacio, Icono } from '../../ui';
import { ICONO_AVISO, accionDeAviso } from './avisos';
import { Buscador, rutaDeBusqueda } from '../publico/Buscador';
import { TarjetaDeTurno } from './TarjetaDeTurno';

/** El inicio de un paciente con sesión: su próximo turno antes que la portada. */
export function InicioPaciente() {
  const { usuario } = useSesion();
  const turnos = usePedido(() => paciente.turnos('proximos'), []);
  const avisos = usePedido(() => paciente.avisos(), []);
  const proximo = turnos.datos?.[0];

  return (
    <div className="inicio-paciente">
      <h1>Hola, {usuario?.nombre}</h1>
      <Buscador alBuscar={(texto) => irA(rutaDeBusqueda(texto))} />

      <section>
        <div className="inicio-paciente__titulo">
          <h2>Tu próximo turno</h2>
          <Enlace a="/mis-turnos">Ver todos</Enlace>
        </div>
        {proximo
          ? <TarjetaDeTurno turno={proximo} />
          : turnos.estado === 'listo' && (
            <EstadoVacio icono="calendar" titulo="Sin turnos próximos" cuerpo="Buscá un profesional y reservá en minutos."
              accion={<Boton onClick={() => irA('/buscar')}>Buscar profesionales</Boton>} />
          )}
      </section>

      {avisos.datos && avisos.datos.length > 0 && (
        <section>
          <div className="inicio-paciente__titulo">
            <h2>Avisos</h2>
            <Enlace a="/mi-cuenta">Ver en mi cuenta</Enlace>
          </div>
          <ul className="inicio-paciente__avisos">
            {avisos.datos.slice(0, 3).map((a) => (
              <li key={`${a.tipo}-${a.id_turno}`}>
                <div>
                  <Icono nombre={ICONO_AVISO[a.tipo]} tamano={18} />
                  <span><strong>{a.titulo}</strong> {a.cuerpo}</span>
                </div>
                <Boton tamano="chico" variante={a.tipo === 'resena' ? 'primario' : 'secundario'}
                  onClick={() => irA(accionDeAviso(a).ruta)}>{accionDeAviso(a).texto}</Boton>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
